import "./TypingIndicator.scss"

import React from "react"
import { i18n } from "@lingui/core"

// Tùy biến KHCN: "Long Mentor đang nhập..." dưới ô bình luận, dữ liệu từ luồng thời gian thực
interface TypingIndicatorProps {
  names: string[]
}

export const TypingIndicator = (props: TypingIndicatorProps) => {
  if (props.names.length === 0) {
    return null
  }
  const text =
    props.names.length === 1
      ? i18n._({ id: "khcn.typing.one", message: "{name} is typing", values: { name: props.names[0] } })
      : props.names.length === 2
      ? i18n._({ id: "khcn.typing.two", message: "{a} and {b} are typing", values: { a: props.names[0], b: props.names[1] } })
      : i18n._({ id: "khcn.typing.many", message: "{name} and {count} others are typing", values: { name: props.names[0], count: props.names.length - 1 } })

  return (
    <div className="c-typing" role="status" aria-live="polite">
      <span className="c-typing__dots" aria-hidden="true">
        <span />
        <span />
        <span />
      </span>
      <span className="c-typing__text">{text}</span>
    </div>
  )
}
